module.exports = __webpack_public_path__ + "static/media/fyf.9359936d.jpg";